export const colors = {
  brand: {
    primary: '#1d63f3',
    secondary: '#5eff5d',
    sapphire: '#174cb8',
    mantis: '#62ce61',
    blueStone: '#066860',
    lightCrimson: '#ff6498'
  }
}
